// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const safeJsonParse = <T> (text: string, guard: (obj: any) => obj is T) => {
  const payload = JSON.parse(text);
  return guard(payload) ? payload : null;
};
